import React from 'react'

const HopeOfflinePaymentResult = ({offlinePmtMsg}) => {
  return (
    <pre style={{fontSize: "14px",
    fontFamily: 'Roboto, Helvetica Neue, Arial, sans-serif'}}>
      {offlinePmtMsg}
    </pre>
  )
}

export default HopeOfflinePaymentResult